const breakpoints = {
  values: { xs: 0, sm: 600, md: 900, lg: 1200, lgxl: 1250, xl: 1432 }
};
export default breakpoints;
